import React from 'react';
import { all, takeEvery, takeLeading, put, call } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import { Toast } from '../../utils/helper';
import {
    GENERATE_QUESTION,
    POST_QUESTION,
    DELETE_QUESTION_SET,
    GET_QUESTION_LIBRARY,
    GET_ALL_PERMISSION,
    GET_USER_INFORMATION,
    FETCH_LANGUAGE_QUESTION,
    TRANSLATE_QUESTIONS,
    FETCH_PSYCHOMETRIC_ROLES,
} from '../action/types';
import {
    generateQuestionSuccess,
    generateQuestionFailure,
    createOrUpdateQuestionSuccess,
    createOrUpdateQuestionFailure,
    deleteQuestionSetSuccess,
    deleteQuestionSetFailure,
    getQuestionLibrarySuccess,
    getQuestionLibraryFailure,
    getAllPermissionSuccess,
    getAllPermissionFailure,
    getUserInformationFailure,
    getUserInformationSuccess,
    fetchLanguageQuestionSuccess,
    fetchLanguageQuestionFailure,
    translateQuestionsSuccess,
    translateQuestionsFailure,
    fetchPsychometricRolesSuccess,
    fetchPsychometricRolesFailure,
} from '../action';
import INTERVIEW from '../../utils/api/interview';
import USERS from '../../utils/api/users';
function* fetchLanguageQuestionRequest(action) {
    try {
        const res = yield INTERVIEW.post(`incbot/fetchLanguageQuestion`, action?.payload?.payload);
        if (res.status === 201 || res.status === 200) {
            yield put(fetchLanguageQuestionSuccess());
            yield call(action.payload.callback(res.data?.result?.data));
        }
    } catch (e) {
        yield put(fetchLanguageQuestionFailure());
        yield e?.response?.data?.message &&
            e?.response?.data?.message !== 'Your session has been expired, please login again!' &&
            toast.error(<Toast msg={e?.response?.data?.message} />, {
                autoClose: 5000,
                toastId: e?.response?.data?.message,
            });
    }
}
function* postQuestionRequest(action) {
    const {
        position,
        label,
        questions,
        instructions,
        totalQuestion,
        interviewDuration,
        psychometricTotalDuration,
        questionId,
        type,
        aptitude,
        positionSpecificQuestions,
        writtenTestQuestions,
        codingQuestions,
        conversationAIStatus,
        evaluationType,
        fullyConversational,
        durationMinutes,
        selectedDuration,
        aiPersonaForm,
        aiPersona,
        interviewLanguages,
        specificDuration,
        interviewType,
        sectionsData,
        difficultyLevel,
        technicalMcqs,
        psychometricSkills, // Set in AddQuestions when interviewType is psychometric_assessment
        psychometricRole,
        psychometricLevel,
    } = action?.payload?.finalQuestionForm;
    try {
        console.log('Posting question with data:', action?.payload?.finalQuestionForm);
        let Data = {
            position,
            label,
            questions: questions || [],
            instruction: instructions,
            totalQuestion,
            // Psychometric: backend expects totalDuration to reflect active skills only.
            totalDuration:
                interviewType === 'psychometric_assessment'
                    ? (psychometricTotalDuration ?? interviewDuration)
                    : interviewDuration,
            type,
            conversationAIStatus,
            positionSpecificQuestions: positionSpecificQuestions || {
                questions: [],
            },
            writtenTestQuestions: writtenTestQuestions || { questions: [] },
            codingQuestions,
            evaluationType:
                interviewType === 'psychometric_assessment' ? 'question_based' : evaluationType || 'question_based',
            fullyConversational,
            durationMinutes,
            selectedDuration,
            codingAndAptitude: action?.payload?.finalQuestionForm?.codingAndAptitude || false,
            aiPersona,
            interviewLanguages,
            specificDuration,
        };
        const companyInfo = action?.payload?.finalQuestionForm?.companyInfo;
        if (interviewType) Data.interviewType = interviewType;
        // Sends multipart: positions/question reads `data` JSON field.
        if (interviewType === 'psychometric_assessment') {
            if (psychometricLevel) Data.psychometricLevel = psychometricLevel;
            if (psychometricSkills?.length > 0) {
                Data.psychometricSkills = psychometricSkills;
                if (psychometricRole) Data.psychometricRole = psychometricRole;
            }
        }
        if (sectionsData) Data.sectionsData = sectionsData;
        if (difficultyLevel) Data.difficultyLevel = difficultyLevel;
        if (aptitude?.length > 0) Data.aptitude = aptitude;
        if (technicalMcqs?.length > 0) Data.technicalMcqs = technicalMcqs;
        if (questionId) Data.questionId = questionId;
        const formData = new FormData();
        formData.append('data', JSON.stringify(Data));
        formData.append('shortBio', companyInfo?.shortBio || null);
        formData.append('introVideo', companyInfo?.introVideo || null);
        companyInfo?.introVideoLink && formData.append('introVideoLink', companyInfo?.introVideoLink || null);
        if (companyInfo?.introVideoFileName) {
            formData.append('introVideoFileName', companyInfo?.introVideoFileName);
        }

        if (aiPersonaForm) {
            ['file1', 'file2', 'file3', 'file4', 'file5', 'file6', 'file7', 'file8'].forEach((fileKey, index) => {
                if (aiPersonaForm[fileKey] instanceof File) {
                    formData.append(`transcriptFile_${index + 1}`, aiPersonaForm[fileKey]);
                } else if (aiPersonaForm[fileKey]) {
                    formData.append(`transcriptFile_${index + 1}`, JSON.stringify(aiPersonaForm[fileKey]));
                }
            });
            if (aiPersonaForm.audioFile instanceof File) {
                formData.append('audioFile', aiPersonaForm.audioFile);
            } else if (aiPersonaForm.audioFile) {
                formData.append('audioFile', JSON.stringify(aiPersonaForm.audioFile));
            }
            formData.append('botVoice', aiPersonaForm.botVoice);
        }
        console.log('Posting question with data 2:', action?.payload?.finalQuestionForm);
        const res = yield INTERVIEW.post(`positions/question`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        if (res.status === 201) {
            yield put(createOrUpdateQuestionSuccess(res.data.result));
            yield call(action.payload.callback(res.data.result));
        }
    } catch (e) {
        console.log(e, 'Error posting question');
        yield put(createOrUpdateQuestionFailure());
        yield e?.response?.data?.message &&
            e?.response?.data?.message !== 'Your session has been expired, please login again!' &&
            toast.error(<Toast msg={e?.response?.data?.message} />, {
                autoClose: 5000,
                toastId: e?.response?.data?.message,
            });
    }
}
function* deleteQuestionSetRequest(action) {
    try {
        const res = yield INTERVIEW.delete(`positions/question/${action.payload.questionId}`);
        if (res.status === 200 || res.status === 201 || res.status === 204) {
            yield put(deleteQuestionSetSuccess(res.data?.result));
            toast.success(<Toast msg={'Question set deleted successfully.'} />, {
                autoClose: 5000,
                toastId: 'Question set deleted successfully.',
            });
            if (action.payload.callback) yield call(action.payload.callback);
        }
    } catch (e) {
        yield put(deleteQuestionSetFailure());
        const responseMessage = e?.response?.data?.message;
        // The API answers "Invalid Question Set" (400) once the set no longer exists.
        const alreadyDeleted = e?.response?.status === 400 && responseMessage === 'Invalid Question Set';
        if (action.payload.callbackFailure) yield call(action.payload.callbackFailure, { alreadyDeleted });
        let message = responseMessage;
        if (!e?.response) {
            // No response at all: offline or the request never reached the server.
            message = 'Failed to delete question set. Please check your internet connection and try again.';
        } else if (alreadyDeleted) {
            message = 'Question set has already been deleted.';
        } else if (!responseMessage && e.response.status !== 401) {
            message = 'Failed to delete question set. Please try again.';
        }
        yield message &&
            message !== 'Your session has been expired, please login again!' &&
            toast.error(<Toast msg={message} />, {
                autoClose: 5000,
                toastId: message,
            });
    }
}
export function* watchDeleteQuestionSetAPI() {
    yield takeLeading(DELETE_QUESTION_SET, deleteQuestionSetRequest);
}
function* generateQuestionRequest(action) {
    let data = {
        prompt: 'You are a helpful assistant that generates screening questions on the basis of given Job Description. I am giving you a job description required, based on this, generate Screening Questions. You have to act as a HR to generate only 3 Screening Questions. Provide only Questions. No additional information',
        jd: action.payload.jd,
    };
    try {
        const res = yield INTERVIEW.post(`incbot/generateQuestions`, data);
        if (res.status === 201 || res.status === 200) {
            yield put(generateQuestionSuccess(res.data));
            yield call(action.payload.callback(res.data));
        }
    } catch (e) {
        yield put(generateQuestionFailure());
        yield e?.response?.data?.message &&
            e?.response?.data?.message !== 'Your session has been expired, please login again!' &&
            toast.error(<Toast msg={e?.response?.data?.message} />, {
                autoClose: 5000,
                toastId: e?.response?.data?.message,
            });
    }
}
function* getQuestionLibraryRequest() {
    try {
        const res = yield INTERVIEW.get('positions/questionLibrary/incbot');
        if (res.status === 200 || res.status === 201) {
            yield put(getQuestionLibrarySuccess(res.data?.result));
        }
    } catch (e) {
        yield put(getQuestionLibraryFailure());
    }
}
function* getAllPermissionRequest() {
    try {
        const res = yield INTERVIEW.get(`incbot/getAllPermission`);
        if (res.status === 201 || res.status === 200) {
            yield put(getAllPermissionSuccess(res.data?.result));
        } else {
            yield put(getAllPermissionFailure());
        }
    } catch (e) {
        yield put(getAllPermissionFailure());
    }
}
function* fetchPsychometricRolesRequest() {
    try {
        const res = yield INTERVIEW.get(`incbot/psychometricRoles`);
        if (res.status === 201 || res.status === 200) {
            yield put(fetchPsychometricRolesSuccess(res?.data?.result || []));
        } else {
            yield put(fetchPsychometricRolesFailure());
        }
    } catch (e) {
        yield put(fetchPsychometricRolesFailure());
    }
}

function* getUserInformationRequest(action) {
    try {
        const res = yield USERS.get(`users/${action.payload.id}`);
        if (res.status === 200) {
            yield put(getUserInformationSuccess(res.data.result));
            yield call(action.payload.callback, res.data.result);
        }
    } catch (e) {
        yield put(getUserInformationFailure());
    }
}
export function* watchGenerateQuestionAPI() {
    yield takeEvery(GENERATE_QUESTION, generateQuestionRequest);
}
export function* watchPostQuestionAPI() {
    yield takeEvery(POST_QUESTION, postQuestionRequest);
}
export function* watchGetQuestionLibrary() {
    yield takeEvery(GET_QUESTION_LIBRARY, getQuestionLibraryRequest);
}
export function* watchGetAllPermission() {
    yield takeLeading(GET_ALL_PERMISSION, getAllPermissionRequest);
}
export function* watchGetUserInformationAPI() {
    yield takeEvery(GET_USER_INFORMATION, getUserInformationRequest);
}
export function* watchFetchLanguageQuestionAPI() {
    yield takeEvery(FETCH_LANGUAGE_QUESTION, fetchLanguageQuestionRequest);
}
export function* watchFetchPsychometricRolesAPI() {
    yield takeEvery(FETCH_PSYCHOMETRIC_ROLES, fetchPsychometricRolesRequest);
}
function* translateQuestionsRequest(action) {
    try {
        const res = yield INTERVIEW.post(`incbot/translateQuestions`, action?.payload?.payload);
        if (res.status === 201 || res.status === 200) {
            yield put(translateQuestionsSuccess());
            action?.payload?.callback && action.payload.callback(res.data?.result?.data);
        } else {
            yield put(translateQuestionsFailure());
            action?.payload?.errorCallback && action.payload.errorCallback();
        }
    } catch (e) {
        yield put(translateQuestionsFailure());
        action?.payload?.errorCallback && action.payload.errorCallback();
    }
}
export function* watchTranslateQuestionsAPI() {
    yield takeEvery(TRANSLATE_QUESTIONS, translateQuestionsRequest);
}
export default function* rootSaga() {
    yield all([
        watchGenerateQuestionAPI(),
        watchPostQuestionAPI(),
        watchDeleteQuestionSetAPI(),
        watchGetQuestionLibrary(),
        watchGetAllPermission(),
        watchFetchLanguageQuestionAPI(),
        watchFetchPsychometricRolesAPI(),
        watchTranslateQuestionsAPI(),
    ]);
}
